import { Card, Text, textVariants } from '@etg/wings';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { css } from '@eti/styles';
import { InfoItem } from './InfoItem';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const loungeInfoContainer = css`
  background-color: #fafafa;

  & > div:not(:last-child) {
    margin-bottom: 16px;
  }
`;
const listStyles = css`
  display: inline;
  margin-inline-end: 4px;

  &:not(:last-child)::after {
    content: ', ';
  }
`;
const AvailabilityAccordion = ({
  openingFrom,
  openingTo,
  openingTitle,
  amenities: amenitiesText,
  location,
  condition: conditionText,
  terminal: terminalText,
  loungeInfo
}) => {
  var _loungeInfo$amenities, _loungeInfo$condition;
  return /*#__PURE__*/_jsxs(Card, {
    className: loungeInfoContainer,
    "data-testid": "availability-accordion-lounge-card",
    id: "availability-accordion-info-content",
    children: [/*#__PURE__*/_jsx(InfoItem, {
      title: openingTitle,
      children: /*#__PURE__*/_jsxs("div", {
        "data-testid": "availability-opening-hours",
        children: [openingFrom, " ", /*#__PURE__*/_jsx(Text, {
          variant: textVariants._14_BOLD,
          children: loungeInfo.openAt
        }), " ", openingTo, ' ', /*#__PURE__*/_jsx(Text, {
          variant: textVariants._14_BOLD,
          children: loungeInfo.closeAt
        })]
      })
    }), /*#__PURE__*/_jsx(InfoItem, {
      title: amenitiesText,
      children: /*#__PURE__*/_jsx("ul", {
        children: (_loungeInfo$amenities = loungeInfo.amenities) === null || _loungeInfo$amenities === void 0 ? void 0 : _loungeInfo$amenities.map((amenity, index) => /*#__PURE__*/_jsx("li", {
          className: listStyles,
          children: /*#__PURE__*/_jsx(Text, {
            spacing: 4,
            children: amenity === null || amenity === void 0 ? void 0 : amenity.name
          })
        }, amenitiesText + index))
      })
    }), /*#__PURE__*/_jsx(InfoItem, {
      title: location,
      children: /*#__PURE__*/_jsxs("div", {
        children: [terminalText, " ", loungeInfo.terminal]
      })
    }), /*#__PURE__*/_jsx(InfoItem, {
      title: conditionText,
      children: /*#__PURE__*/_jsx("ul", {
        children: (_loungeInfo$condition = loungeInfo.conditions) === null || _loungeInfo$condition === void 0 ? void 0 : _loungeInfo$condition.map((condition, index) => /*#__PURE__*/_jsx("li", {
          className: listStyles,
          children: /*#__PURE__*/_jsx(Text, {
            children: condition === null || condition === void 0 ? void 0 : condition.description
          })
        }, conditionText + index))
      })
    })]
  });
};
export default AvailabilityAccordion;
//# sourceMappingURL=AvailabilityAccordion.js.map